import { render, staticRenderFns } from "./TipolugarModalNuevo.vue?vue&type=template&id=4a623611&scoped=true&"
import script from "./TipolugarModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipolugarModalNuevo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a623611",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a623611', component.options)
    } else {
      api.reload('4a623611', component.options)
    }
    module.hot.accept("./TipolugarModalNuevo.vue?vue&type=template&id=4a623611&scoped=true&", function () {
      api.rerender('4a623611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipolugarModalNuevo.vue"
export default component.exports